<script>
import resources from './resources'

export default {
  name: 'professional-graduations',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row.border-top(style="margin-bottom: 20px; width: 97%;")
      .col-xs-12.col-sm-6.margin-bottom
        small.grey Especialização
        br
        span#professionalName.blue(style="font-size: 15px;") {{ specialization.area }}
        br
        small.grey Área de Especialidade
        br
        span#professionalName.blue(style="font-size: 15px;") {{ specialization.specialities.name }}
      .col-xs-12.col-sm-6.margin-bottom
        small.grey Instituição de Ensino
        br
        span#professionalName.blue(style="font-size: 15px;") {{ specialization.entity_name }}
        br
        small.grey(v-if="specializationStart != 'Invalid date' && specializationEnd != 'Invalid date'") Período
        br
        span#professionalName.blue(style="font-size: 15px;", v-if="specializationStart != 'Invalid date' && specializationEnd != 'Invalid date'") {{ specializationStart }} &mdash; {{ specializationEnd }}

</template>
<style>
.border-top {
  margin-top: 10px;
  margin-bottom: 20px;
  border-top: 1px solid rgb(221, 221, 221);
}
.border-top-botton {
  border-bottom: 1px solid #ddd;
}
.grey {
  color: #93959b;
  font-weight: bold;
  font-size: 12px;
}
.blue {
   color: #2071b9;
   font-size: 1.2em;
   font-weight: 700;
   display: block;
}
.small, small {
    font-size: 85%;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-company/components/specializations/specialization.vue